// extracted by mini-css-extract-plugin
module.exports = {"root":"root___W3Je4","list":"list___32pUr"};